import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2hhbtdht4d: FaireBrandEntity = {
  token: "b_2hhbtdht4d",
  type: "brand",
  name: "The Beekeeper's Daughter",
  avatarUrl:
    "https://cdn.faire.com/fastly/b0ef9f125848e83ecc598ba438776ecdfcc5c090fc07e65b14132b2eb063173b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b2e8684d0df1fa598e556644def9f018467943dfcecb6569a390d0fa50f2f5ab.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b0ef9f125848e83ecc598ba438776ecdfcc5c090fc07e65b14132b2eb063173b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b2e8684d0df1fa598e556644def9f018467943dfcecb6569a390d0fa50f2f5ab.png",
  location: "Plains, PA, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 123,
  isTopShop: true,
  isInsider: true,
  description:
    "Beekeeping has been a part of our family since the 1800’s, when our family was hobbyist beekeepers. Our honey producing business was established in the early 1950’s in Dallas, Pa by my grandfather William Perry Sr. As the years went past, more and more hives were being kept due to the demand for American honey and we have eventually buzzed our way to thousands of hives. I eventually started The Beekeeper's Daughter in 2012 to expand our own private label along with many other products from the hive, such as honey soda and creamy honey. What started out as a small business venture, has grown to become our family life. \n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:05.832Z",
    importedBy: "entity-db-cli",
  },
};
